export default __webpack_public_path__ + "static/media/stain-inactive.29f01b67.png";